import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SUPPORTED_LANGS = ['es', 'en', 'zh'] as const;
type SupportedLang = (typeof SUPPORTED_LANGS)[number];

const isSupportedLang = (value: string): value is SupportedLang => {
  return SUPPORTED_LANGS.includes(value as SupportedLang);
};

export const useLocalizedPath = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const currentPathLang = location.pathname.split('/').filter(Boolean)[0] || '';
  const i18nLang = i18n.language?.split('-')[0] || '';
  const lang: SupportedLang = isSupportedLang(currentPathLang)
    ? currentPathLang
    : isSupportedLang(i18nLang)
      ? i18nLang
      : 'es';

  return (path: string) => {
    if (!path || path.startsWith('#') || /^(https?:)?\/\//.test(path)) {
      return path;
    }

    if (SUPPORTED_LANGS.some((code) => path === `/${code}` || path.startsWith(`/${code}/`))) {
      return path;
    }

    return path === '/' ? `/${lang}` : `/${lang}${path}`;
  };
};

